import { z } from 'zod'

/** Formato único de erro da API. O frontend só precisa entender este. */
export interface ErroApi {
  erro: string
  mensagem: string
  campos?: Record<string, string>
}

export const paginacaoSchema = z.object({
  pagina: z.coerce.number().int().min(1).default(1),
  tamanho: z.coerce.number().int().min(1).max(200).default(50),
})

export interface Pagina<T> {
  itens: T[]
  total: number
  pagina: number
  tamanho: number
}

export const idSchema = z.object({ id: z.string().uuid('id inválido') })

/**
 * Booleano vindo de querystring.
 *
 * NÃO use `z.coerce.boolean()` para isto: ele faz `Boolean("false")`, que é
 * `true`. Toda caixa de seleção desmarcada chegaria marcada no servidor, e o
 * filtro simplesmente não funcionaria — sem erro nenhum para dar pista.
 */
export function booleanoDeQuery(padrao: boolean) {
  return z
    .union([z.boolean(), z.string()])
    .optional()
    .transform((valor) => {
      if (valor === undefined || valor === '') return padrao
      if (typeof valor === 'boolean') return valor
      const texto = valor.trim().toLowerCase()
      if (['true', '1', 'sim', 'on'].includes(texto)) return true
      if (['false', '0', 'nao', 'não', 'off'].includes(texto)) return false
      return padrao
    })
}

/** Texto que não pode ser só espaço em branco. */
export function textoObrigatorio(rotulo: string, max = 160) {
  return z
    .string()
    .trim()
    .min(1, `${rotulo} é obrigatório`)
    .max(max, `${rotulo} passa de ${max} caracteres`)
}
